import adjustTicketTimeNumber from "./adjustTicketTimeNumber";
import millisecondsToTime from "./datetime/millisecondsToTime";
import { i18n } from "../translate/i18n";

const validateLongAwaitingTimeTickets = (ticketsList, awaitingTimeSetting, considerOnlyWhatsappTickets=false) => {
  if (awaitingTimeSetting === -1) return false;

  const tempTicketsList = considerOnlyWhatsappTickets ? ticketsList.filter(ticket => [0, "0"].includes(ticket.type)) : ticketsList;

  for (const ticket of tempTicketsList) {
    const timeAwaiting = millisecondsToTime(new Date() - new Date(ticket.createdAt));

    let [timeAwaitingNumber, timeAwaitingMetric] = [parseInt(timeAwaiting.split(" ")[0]), timeAwaiting.split(" ")[1]];
    timeAwaitingNumber = adjustTicketTimeNumber(timeAwaitingNumber, timeAwaitingMetric);
    
    const secondMetrics = [i18n.t("ticketsList.timeAwaitSecond"), i18n.t("ticketsList.timeAwaitSecond") + "s"];
    
    if (timeAwaitingNumber >= awaitingTimeSetting && !secondMetrics.includes(timeAwaitingMetric)) return true;
  }

  return false;
};

export default validateLongAwaitingTimeTickets;
